import React from "react";
import {
  Input,
  Text,
  TextInput,
  Select,
  Button,
  Tooltip,
  Loader,
  Modal,
  LoadingOverlay,
} from "@mantine/core";

export default function PrivacyPolicy({ setOpenedPrivacy }) {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div style={{ width: "90%", padding: 20, margin: 20 }}>
        <Text size="lg" weight="bold">
          Owner & Data Controller
        </Text>
        <Text size="sm">Adly AB (reg no. 559282-8239) </Text>
        <Text size="sm">Teknikringen 7 </Text>
        <Text size="sm">583 30 Linköping </Text>
        <Text size="sm">Owner contact email: gustav@adly.gg</Text>
        <Text size="lg" weight="bold" mt="lg">
          Data Being Collected
        </Text>
        <Text size="sm">
          Identification data: First name and surname, user name. In the case of
          contact through social media - also the user name in these media.{" "}
        </Text>
        <Text size="sm" mt="sm">
          Contact data: First name, surname, user name. In case of contact
          through social media - also the user name in these media. If you
          subscribe to the newsletter, contact data refers only to the provided
          name and email address.{" "}
        </Text>
        <Text size="sm" mt="sm">
          Data related to image: Image of a person who has concluded a contract
          with Adly.{" "}
        </Text>
        <Text size="sm" mt="sm">
          Financial data: Bank account number.{" "}
        </Text>
        <Text size="sm" mt="sm">
          {" "}
          Technical data: Internet Protocol address (IP), browser type and
          version, setting and location of the time zone, types and versions of
          browser plug-ins, operating system and platform, other technologies
          applied in devices employed by the user in order to access this
          website.{" "}
        </Text>
        <Text size="sm" mt="sm">
          {" "}
          User data: Information about the manner of the website or services
          (tracking behavior).
        </Text>
        <Text size="sm" mt="sm">
          Tracking data: Information that is collected about the user by Adly or
          other entities using cookies and similar tracking technologies, such
          as web beacons, pixels and mobile device identifiers.
        </Text>
        <Text size="sm" mt="sm">
          Adly does not collect sensitive data (data of special category),
          including data revealing one’s racial or ethnic origin, religious
          beliefs, data concerning sexual life and orientation, political views,
          information about health and diseases as well as biometric and genetic
          data. ‍
        </Text>
        <Text size="lg" weight="bold" mt="lg">
          How The Data Is Collected
        </Text>
        <Text size="sm">
          Adly uses the following methods to collect personal data:
        </Text>
        <Text size="sm" mt="sm">
          Direct interactions: The user provides data directly to Adly. The
          provision is performed upon registration (conclusion of a contract),
          contact by mail or by phone and contract (lease of advertising space).
          In this manner, we collect Identification data, Contact data, Data
          related to image and Financial data.
        </Text>
        <Text size="sm" mt="sm">
          Automated activities: Data is collected automatically during
          interactions with Adly (also through the website) by cookies and
          analytic tools (Google Analytics). In this manner we collect Technical
          data, User data and Tracking data. We may also collect Aggregated
          data.
        </Text>
        <Text size="sm" mt="sm">
          From Third Parties: Data are provided by entities which are external
          in relation to Adly (including entities providing tracking services,
          statistical services, etc. as well as entities providing solutions
          related to logging-in, e.g. Google Sign-In), if these entities have a
          legal basis for such provision. This basis usually consists in the
          user’s consent. In this manner, we collect Technical data, User data
          and Tracking data. We may also obtain Financial data (payments
          operators) and, upon authentication, Identification data and Contact
          data (social portals, streaming portals). Necessary Personal data may
          be obtained by Adly also through API placed in portals of business
          partners of Adly and entities providing services for Adly.
        </Text>
        <Text size="lg" weight="bold" mt="lg">
          How The Collected Data Is Used
        </Text>
        <Text size="sm">Adly uses data for the purpose of:</Text>
        <Text size="sm" mt="sm">
          a) Performance of services provided by electronic means, and in the
          case of users with whom a contract has been concluded – also for the
          purpose of performance of that contract;‍
        </Text>
        <Text size="sm" mt="sm">
          b) Performance of other services;‍
        </Text>
        <Text size="sm" mt="sm">
          c) Handling of inquiries, requests and orders
        </Text>
        <Text size="sm" mt="sm">
          d) Marketing activities (marketing of own products)
        </Text>
        <Text size="sm" mt="sm">
          e) Analysis and improvement of the functioning of websites and
          services provided by Adly
        </Text>
        <Text size="sm" mt="sm">
          f) Development, repair or tests of various functionalities
        </Text>
        <Text size="lg" weight="bold" mt="lg">
          Data Provision
        </Text>
        <Text size="sm">
          As a rule, data collected by Adly are not shared with third parties.
          However, Adly may:
        </Text>
        <Text size="sm" mt="sm">
          a) Share data of persons who have concluded a contract with Adly
          (lease of advertising space) with advertisers at the stage of their
          deciding about cooperation with Adly, as well as information about the
          implemented campaigns;
        </Text>
        <Text size="sm" mt="sm">
          b) Share data of persons who have used the services of Adly with
          entities supporting Adly in the provision of services, such as payment
          processors or providers of analytic tools (e.g. Google Analytics);
        </Text>
        <Text size="sm" mt="sm">
          c) Provide data to law enforcement authorities, supervisory bodies,
          entities performing public tasks or other entities, if the obligation
          to provide data results from the legal provisions. The provision of
          data must always be performed based on the legal provision or the
          relevant contract (outsourcing of personal data processing).
        </Text>

        <Text size="lg" weight="bold" mt="lg">
          Cookies And Analytics
        </Text>
        <Text size="sm">
          Cookies consist of small text information in the form of text files
          which are sent by the server and saved on the side of the person
          visiting websites (e.g. on the hard disk of a computer or laptop or on
          the smartphone memory card – depending on the device employed by the
          user).
        </Text>
        <Text size="sm" mt="sm">
          As a standard, most web browsers available in the market accept saving
          cookies by default. Everyone is able to define the conditions of using
          cookies by means of settings of their web browser. This means that the
          possibility of saving cookies may be e.g. partially limited (e.g. in
          time) or totally disabled – however, in the latter case, it may affect
          some functionalities of websites.
        </Text>
        <Text size="sm" mt="sm">
          Adly may use the following cookies: Google Analytics These files are
          necessary for traffic analysis and are not essential for the proper
          functioning of websites of Adly. Adly offers an easy way to disable
          these files.
        </Text>
        <Text size="sm" mt="sm">
          Google Analytics - Adly uses the services of Google Analytics and its
          functions provided by Google Inc. These services support Adly in
          analyzing and enhancing its websites and the services provided through
          them. Along with advertising functions, Google Analytics employs
          cookies to analyze the manner of use of websites. The data received
          are processed in an aggregate and anonymous manner (which means that
          they prevent identification of a given person. However, these data may
          be merged with other data. Then, they constitute personal data for
          Adly). Everyone may block the transfer of data from electronic devices
          to Google Analytics by downloading and installing a free browser
          plug-in available here. More information about the Google Analytics
          tool is available here.
        </Text>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            mt="lg"
            onClick={() => {
              setOpenedPrivacy(false);
            }}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
